import { render, staticRenderFns } from "./MPopupAccountUnsubscribe.vue?vue&type=template&id=08cd6c96&"
import script from "./MPopupAccountUnsubscribe.vue?vue&type=script&lang=ts&"
export * from "./MPopupAccountUnsubscribe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports